import React, {PropTypes} from 'react';
import SearchResultItemContainer from './SearchResultItemContainer.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';
import IncludePastTournamentsCheckboxContainer from './IncludePastTournamentsCheckboxContainer.jsx';

const SearchResult = ({
  source
}) => (
  <DisplayIf condition={source !== null}
    className="animated fadeIn">
    <IncludePastTournamentsCheckboxContainer />
    <br />
    {source && source.length
      ? <div className="list-group">
          {source.map((item, index) => (
            <SearchResultItemContainer key={index}
              {...item}
            />
          ))}
        </div>
      : <div className="alert alert-info">{'Nothing found, please try again.'}</div>
    }
  </DisplayIf>
);

SearchResult.propTypes = {
  source: PropTypes.arrayOf(PropTypes.object)
};

SearchResult.defaultProps = {
  source: null
};

export default SearchResult;



// WEBPACK FOOTER //
// ./src/features/admin/home/SearchResult.jsx